/* ==========================================================================
   Studio Mini - favoritliste (wishlist)
   Bygget 22-08-2026 efter Louises oenske: gem varer som favorit, og se listen
   igen via et ikon ved siden af kurven.

   Listen gemmes i browserens localStorage under noeglen 'studiomini:wishlist'
   som en liste af produkt-handles. Der er derfor ingen app og ingen login:
   listen foelger browseren, praecis som en gaestekurv.

   Indholdet i skuffen hentes live fra /products/<handle>.js, saa titel, pris
   og billede altid er opdaterede, og udsolgte varer opdager vi med det samme.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'studiomini:wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return []; // privat browsing / localStorage slaaet fra: favoritter virker bare ikke, resten af siden gør
    }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    sync();
    return i === -1; // true = tilfoejet
  }

  function remove(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    write(list);
    sync();
  }

  /* ---------- UI ---------- */

  function sync() {
    var list = read();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length > 0 ? list.length : '';
      el.closest('.thb-secondary-wishlist')?.classList.toggle('has-items', list.length > 0);
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist-toggle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (label) { btn.setAttribute('aria-label', label); btn.setAttribute('title', label); }
    });
  }

  function money(cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK';
    try {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
    }
  }

  function drawer() { return document.getElementById('Wishlist-Drawer'); }

  /* Temaets OverlayManager er ikke global, og temaets <side-panel-close> kalder
     closeLast() paa sin egen stak. Vores panel er ikke i den stak, saa vi aabner
     OG lukker det selv. Vi holder os til de samme klasser, saa det ser ud og
     opfoerer sig som temaets oevrige paneler. */
  var lastOpener = null;

  function openDrawer() {
    var p = drawer();
    if (!p) return;
    lastOpener = document.activeElement;
    p.classList.add('active');
    p.inert = false;
    document.body.classList.add('open-cc');
    render();
    p.querySelector('.side-panel-close')?.focus();
  }

  function closeDrawer() {
    var p = drawer();
    if (!p || !p.classList.contains('active')) return;
    p.classList.remove('active');
    p.inert = true;
    // Fjern kun overlayet hvis der ikke er et andet panel aabent
    if (!document.querySelector('.side-panel.active')) {
      document.body.classList.remove('open-cc');
    }
    if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
    lastOpener = null;
  }

  function isOpen() { var p = drawer(); return !!p && p.classList.contains('active'); }

  /*
   * renderList bruges baade af skuffen og af den delte oenskeliste-side.
   * `removable` styrer om der er et kryds til at fjerne varen: paa en delt
   * liste er varerne ikke modtagerens egne, saa der skal ikke vaere kryds.
   */
  function renderList(body, list, removable) {
    if (!body) return;

    if (!list.length) {
      body.innerHTML = '<p class="wishlist-empty">' + (body.getAttribute('data-empty') || '') + '</p>';
      return;
    }

    body.innerHTML = '<p class="wishlist-loading">' + (body.getAttribute('data-loading') || '') + '</p>';

    Promise.all(list.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var gone = [];
      var html = items.map(function (p, i) {
        if (!p) { gone.push(list[i]); return ''; }
        var img = p.featured_image ? p.featured_image + '&width=200' : '';
        var soldOut = p.available ? '' : '<span class="wishlist-item__soldout">' + (body.getAttribute('data-soldout') || '') + '</span>';
        // Kun een koebbar variant: saa kan vi trygt laegge den i kurven herfra.
        // Flere varianter: send ind paa produktet, vi gaetter ikke en stoerrelse.
        var buyable = (p.variants || []).filter(function (v) { return v.available; });
        var action;
        if (!p.available) {
          action = '';
        } else if (p.variants && p.variants.length === 1 && buyable.length === 1) {
          action = '<button type="button" class="wishlist-item__action" data-wishlist-add="' + buyable[0].id + '">' +
                     (body.getAttribute('data-addtocart') || '') + '</button>';
        } else {
          action = '<a class="wishlist-item__action" href="/products/' + p.handle + '">' +
                     (body.getAttribute('data-choose') || '') + '</a>';
        }
        return '' +
          '<li class="wishlist-item" data-handle="' + p.handle + '">' +
            '<a class="wishlist-item__image" href="/products/' + p.handle + '">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy" width="80" height="100">' : '') +
            '</a>' +
            '<div class="wishlist-item__info">' +
              '<a class="wishlist-item__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
              '<div class="wishlist-item__price">' + money(p.price) + soldOut + '</div>' +
              action +
            '</div>' +
            (removable
              ? '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + p.handle + '" aria-label="' + (body.getAttribute('data-remove') || 'Fjern') + '">&times;</button>'
              : '') +
          '</li>';
      }).join('');

      // Ryd kun op i EGEN liste. En delt liste maa ikke roere modtagerens favoritter.
      if (removable && gone.length) { write(read().filter(function (h) { return gone.indexOf(h) === -1; })); sync(); }

      body.innerHTML = html ? '<ul class="wishlist-list">' + html + '</ul>'
                            : '<p class="wishlist-empty">' + (body.getAttribute('data-empty') || '') + '</p>';
    });
  }

  function render() {
    renderList(document.getElementById('Wishlist-Drawer-Content'), read(), true);
    var footer = document.querySelector('.wishlist-share');
    if (footer) footer.hidden = read().length === 0;
  }

  /* ---------- deling ---------- */

  function shareUrl(base) {
    var list = read();
    if (!list.length) return null;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    /* data-url er absolut (shop.url). Foer blev origin sat foran igen, saa det
       delte link blev "https://studiominishop.dkhttps://studiominishop.dk/pages/..."
       og kunne ikke aabnes af modtageren (Louise 11-09-2026). URL() haandterer
       baade absolut og relativ base. */
    var u = new URL(base || (root.replace(/\/$/, '') + '/pages/onskeliste'), window.location.origin);
    /* Kommaet sendes som %2C: nogle besked-apps afslutter et link ved et raat
       komma, saa modtageren kun fik det foerste produkt eller et doedt link.
       URLSearchParams afkoder begge dele, saa gamle links virker stadig. */
    u.search = 'l=' + list.map(encodeURIComponent).join('%2C');
    return u.href;
  }

  function sharedHandles() {
    var raw = new URLSearchParams(window.location.search).get('l');
    if (!raw) return null;
    return raw.split(',')
      .map(function (h) { return decodeURIComponent(h).trim(); })
      // kun rigtige handles, saa en manipuleret adresse ikke kan smugle markup ind
      .filter(function (h) { return /^[a-z0-9][a-z0-9-]*$/i.test(h); })
      .slice(0, 100);
  }

  function renderSharedPage() {
    var box = document.getElementById('Wishlist-Shared');
    if (!box) return;
    // boot() koeres baade paa DOMContentLoaded og med det samme naar scriptet
    // naaede at loade bagefter, saa noten maa kun saettes ind een gang.
    if (box.dataset.rendered) return;
    box.dataset.rendered = '1';
    var shared = sharedHandles();
    var note = document.createElement('p');
    note.className = 'wishlist-shared__note';
    note.textContent = shared ? (box.getAttribute('data-from') || '') : (box.getAttribute('data-own') || '');
    box.parentNode.insertBefore(note, box);
    renderList(box, shared || read(), !shared);
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation(); // kortet er et link, undgaa at hjertet navigerer
      toggle(toggleBtn.getAttribute('data-wishlist-toggle'));
      if (drawer() && drawer().classList.contains('active')) render();
      return;
    }
    var open = e.target.closest('[data-wishlist-open]');
    if (open) { e.preventDefault(); openDrawer(); return; }

    if (isOpen()) {
      // egen luk: X'et i panelet, eller klik paa det moerke overlay
      if (e.target.closest('#Wishlist-Drawer .side-panel-close')) { e.preventDefault(); closeDrawer(); return; }
      if (e.target.closest('.click-capture')) { closeDrawer(); return; }
    }

    var share = e.target.closest('[data-wishlist-share]');
    if (share) {
      e.preventDefault();
      var url = shareUrl(share.getAttribute('data-url'));
      if (!url) return;
      var label = share.querySelector('span') || share;
      var done = function () {
        var original = share.getAttribute('data-original') || label.textContent;
        share.setAttribute('data-original', original);
        label.textContent = share.getAttribute('data-copied') || original;
        share.classList.add('is-done');
        setTimeout(function () { label.textContent = original; share.classList.remove('is-done'); }, 2500);
      };
      /* Linket vises altid i et felt under knappen. I in-app browsere (Instagram,
         Facebook, Messenger m.fl.) findes hverken navigator.share eller clipboard,
         og window.prompt returnerer bare null uden at vise noget, saa knappen saa
         doed ud (Louise 14-09-2026). Et markerbart felt virker overalt. */
      var field = share.parentNode.querySelector('.wishlist-share__link');
      if (!field) {
        field = document.createElement('input');
        field.type = 'text';
        field.readOnly = true;
        field.className = 'wishlist-share__link';
        field.setAttribute('aria-label', share.getAttribute('data-title') || '');
        share.parentNode.insertBefore(field, share.nextSibling);
      }
      field.value = url;
      field.hidden = false;
      var failed = function () {
        label.textContent = share.getAttribute('data-failed') || label.textContent;
        field.focus();
        try { field.setSelectionRange(0, url.length); } catch (err) { field.select(); }
      };
      /* Paa mobil er den native del-menu den rigtige. Paa desktop findes
         navigator.share ogsaa i Chrome, men der forventer man at linket bare
         bliver kopieret, saa vi ser efter en touch-enhed frem for API'et. */
      var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
      if (navigator.share && touch) {
        navigator.share({ title: share.getAttribute('data-title') || document.title, url: url })
          .then(done)
          .catch(function (err) { if (err && err.name === 'AbortError') return;
            if (navigator.clipboard) { navigator.clipboard.writeText(url).then(done).catch(failed); } else { failed(); } });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(done).catch(failed);
      } else {
        failed();
      }
      return;
    }

    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-wishlist-remove')); render(); return; }

    var add = e.target.closest('[data-wishlist-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var original = add.textContent;
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-wishlist-add')), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        add.classList.add('is-done');
        add.textContent = add.closest('.wishlist-item') ? (document.getElementById('Wishlist-Drawer-Content').getAttribute('data-added') || original) : original;
        // fortael temaet at kurven er aendret, saa antallet i headeren opdateres
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () {
        add.disabled = false;
        add.textContent = original;
      });
      return;
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) closeDrawer(); });

  // Hvis temaet aabner et af sine egne paneler (kurv, soeg), lukker vi vores,
  // saa de to overlay-systemer ikke traeder hinanden over taeerne.
  document.addEventListener('panel:open', function (e) {
    if (isOpen() && e.detail && e.detail.panel !== drawer()) closeDrawer();
  });

  function boot() { sync(); renderSharedPage(); }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();

  // saa andre faner ogsaa er opdaterede
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); render(); } });

  window.StudioMiniWishlist = { read: read, toggle: toggle, remove: remove, open: openDrawer, close: closeDrawer, count: function () { return read().length; }, shareUrl: shareUrl };
})();
